import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
let WSelect = class WSelect extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "selectRef", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "enabled", void 0);
    _defineProperty(this, "placeholder", void 0);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "valueKey", void 0);
    _defineProperty(this, "labelKey", void 0);
    _defineProperty(this, "valueOnClear", void 0);
    _defineProperty(this, "clearable", void 0);
    _defineProperty(this, "translateLabel", void 0);
    _defineProperty(this, "popperClass", void 0);
    _defineProperty(this, "autoResize", void 0);
    _defineProperty(this, "autoResizeAdditionalGap", void 0);
    _defineProperty(this, "dataTest", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "realValue", '');
    _defineProperty(this, "selectResizeReferer", null);
  }
  mounted() {
    this.realValue = this.value;
    if (this.autoResize) {
      this.updateSelectWidth();
    }
  }
  /**
   * Returns the display label based on the current translation settings.
   *
   * @param {string} label - The label to be translated or displayed as-is.
   * @return {string} The translated label if translation is enabled; otherwise, the original label.
   */
  labelToDisplay(label) {
    if (this.translateLabel) {
      return this.$t(label);
    } else {
      return label;
    }
  }
  onBlur() {
    this.$emit('blur', this.realValue);
  }
  onChangeValue() {
    if (this.autoResize) {
      this.updateSelectWidth();
    }
    this.$emit('change', this.realValue);
  }
  handleClear() {
    this.$emit('clear', this.realValue);
  }
  getSelectedItemHtmlLabel(selectedItemValue) {
    return this.options.find(o => o[this.valueKey] === selectedItemValue && o.htmlLabel)?.htmlLabel;
  }
  onChangePropValue() {
    this.realValue = this.value;
    if (this.autoResize) {
      this.updateSelectWidth();
    }
  }
  onInputResizeGapChanged() {
    if (this.autoResize) {
      this.updateSelectWidth();
    }
  }
  updateSelectWidth() {
    const elSelectRoot = this.$refs[this.selectRef]?.$el;
    const selection = elSelectRoot?.querySelector('.el-select__selection');
    if (elSelectRoot && selection && this.autoResize) {
      if (!this.selectResizeReferer) {
        this.selectResizeReferer = document.createElement("span");
        this.selectResizeReferer.style.position = "fixed";
        this.selectResizeReferer.style.visibility = "hidden";
        this.selectResizeReferer.style.whiteSpace = "pre";
        document.body.appendChild(this.selectResizeReferer);
      }
      const styles = window.getComputedStyle(selection);
      this.selectResizeReferer.style.fontSize = styles.fontSize;
      this.selectResizeReferer.style.fontFamily = styles.fontFamily;
      this.selectResizeReferer.style.fontWeight = styles.fontWeight;
      let currentSelectionLabel = this.placeholder || '';
      if (this.realValue) {
        const selectedOption = this.options?.find(option => option[this.valueKey] === this.realValue);
        if (selectedOption) {
          currentSelectionLabel = this.getSelectedItemHtmlLabel(this.realValue) ? this.getSelectedItemHtmlLabel(this.realValue) : this.labelToDisplay(selectedOption[this.labelKey]) || currentSelectionLabel;
        }
      }
      this.selectResizeReferer.innerHTML = currentSelectionLabel;
      const selectionWidth = `${Math.ceil((this.selectResizeReferer.getBoundingClientRect().width || 0) + this.autoResizeAdditionalGap)}px`;
      selection.style.width = `${selectionWidth}`;
    }
  }
};
__decorate([Prop({
  default: 'selectRef'
})], WSelect.prototype, "selectRef", void 0);
__decorate([Prop({
  default: 'default'
})], WSelect.prototype, "size", void 0);
__decorate([Prop({
  default: true
})], WSelect.prototype, "enabled", void 0);
__decorate([Prop({
  default: ''
})], WSelect.prototype, "placeholder", void 0);
__decorate([Prop({
  default: ''
})], WSelect.prototype, "value", void 0);
__decorate([Prop({
  default: false
})], WSelect.prototype, "loading", void 0);
__decorate([Prop({
  default: "value"
})], WSelect.prototype, "valueKey", void 0);
__decorate([Prop({
  default: "label"
})], WSelect.prototype, "labelKey", void 0);
__decorate([Prop({
  default: ''
})], WSelect.prototype, "valueOnClear", void 0);
__decorate([Prop({
  default: false
})], WSelect.prototype, "clearable", void 0);
__decorate([Prop({
  default: false
})], WSelect.prototype, "translateLabel", void 0);
__decorate([Prop({
  default: ''
})], WSelect.prototype, "popperClass", void 0);
__decorate([Prop({
  default: false
})], WSelect.prototype, "autoResize", void 0);
__decorate([Prop({
  default: 0
})], WSelect.prototype, "autoResizeAdditionalGap", void 0);
__decorate([Prop()], WSelect.prototype, "dataTest", void 0);
__decorate([Prop({
  default: []
})], WSelect.prototype, "options", void 0);
__decorate([Watch('value')], WSelect.prototype, "onChangePropValue", null);
__decorate([Watch('autoResize'), Watch('autoResizeAdditionalGap')], WSelect.prototype, "onInputResizeGapChanged", null);
WSelect = __decorate([Component({
  emits: ['blur', 'change', 'clear']
})], WSelect);
export default WSelect;